import React, { Fragment } from 'react';
import moment from 'moment';
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// models
import ILocation from '../../models/location.interface';
import { placeholderReplace } from 'src/services/string-helper';
// styles
const styles = require('./booking-items-address.scss');

interface IProps {
  data: any;
  language: string;
  multiLang: any;
}

interface IState {
  data: any;
  location: ILocation;
  changeLocation: boolean;
  altRec: string;
  adtInfo: string;
  submit: boolean;
}

class BookingItemsAddressComponent extends React.Component<IProps, IState> {

  private gMapK = 'AIzaSyCyW4uJWHpGOMJZn_81xm-_PkvY_NH-Dm4';
  public bookingProductService = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      data: props.data,
      location: props.data.collectionLocation !== null
        ? props.data.collectionLocation
        : props.data.deliveryLocation !== null
          ? props.data.deliveryLocation
          : null,
      changeLocation: false,
      altRec: '',
      adtInfo: '',
      submit: false
    }
  }

  changeAltranativehandle() {
    this.setState({ submit: false })
  }
  handleSubmit() {
    this.setState({ submit: true })
  }
  changeAlternativeValueHandler(e) {
    this.setState({ altRec: e })
  }
  changeAdditionalValueHandler(e) {
    this.setState({ adtInfo: e })
  }

  collectionCtaButton(v) {
    if (v === 1) {
      this.setState({ changeLocation: true })
    }
  }

  getImageUrl = (geo, width, height, key) => {
    const str: string = portrSDK.getStaticMap(geo, width, height, key);
    return str;
  }

  deliveryTimeslot() {
    const { language, multiLang } = this.props;

    return (
      <Fragment>
        <hr className={styles.hr} />
        <div className={styles.cardBody}>
          <div className={styles.sectionTimeslot}>
            <p className={styles.textMuted}>{multiLang[`deliverySlotText${language}`]}</p>
            <p className={styles.timeslot}>{this.state.data.deliverySlot.slot}</p>
            <p>{moment(this.state.data.deliverySlot.dateTime).format('dddd Do MMMM')}</p>
          </div>
        </div>
      </Fragment>
    );
  }

  cardHeading() {
    const { language, multiLang } = this.props;
    const { arrivalPreCollectionTrackingStatus } = this.state.data;

    const data = this.state.data.trackingBookingDetails;
    if (data.journeyDirection === 2 && data.addOnProductType[0] === 2) {
      return multiLang[`${arrivalPreCollectionTrackingStatus.titleDisplay}${language}`]
    } else {
      return this.state.data.collectionLocation !== null ? multiLang[`pickupAddressText${language}`] : multiLang[`bagDeliveryText${language}`]
    }
  }

  changeDeliveryScreen() {
    console.log(this.state.data)
    const dataLink = this.state.data.manageMyBookingLink;
    const { language, multiLang } = this.props;
    const { arrivalPreCollectionTrackingStatus } = this.state.data;

    const message = arrivalPreCollectionTrackingStatus.translation ? arrivalPreCollectionTrackingStatus.translation.message : arrivalPreCollectionTrackingStatus.text ? arrivalPreCollectionTrackingStatus.text : '';
    const parameters = arrivalPreCollectionTrackingStatus.translation ? arrivalPreCollectionTrackingStatus.translation.parameters : {};

    return this.state.location !== null
      ? <div className={styles.collectionBooking}>
        <p className={styles.collectionBookingDesc}>{placeholderReplace(multiLang[`${message}${language}`], parameters)}</p>
        <div className={styles.cardBody}>
          <div className={styles.mapHolder}
            style={{ backgroundImage: 'url(' + (this.state.location?.geoCoord?.latitude !== null ? this.getImageUrl(this.state.location?.geoCoord, 600, 200, this.gMapK) : '') + ')' }}>
          </div>
          <div className={styles.sectionAddress}>
            <p className={styles.collectionBookingAddress}>{multiLang[`deliveryAddressText${language}`]}:</p>
            <p>{multiLang[`Postcode${language}`]}: {this.state.location.addressPostCode}</p>
          </div>
        </div>
        <div className={styles.collectionBookingCta}>
          <a href={dataLink} target='_blank' className={styles.collectionBookingBtnSecond}>{multiLang[`changeDeliveryAddressText${language}`]}</a>
          {!this.state.changeLocation ? <button style={{ display: 'none' }} className={styles.collectionBookingBtnPrimary} onClick={() => this.collectionCtaButton(1)}>{multiLang[`notGoingToBeInText${language}`]}</button> : null}
        </div>
        {this.state.changeLocation ?
          <div className={styles.collectionBookingChange}>
            <p>
              {multiLang[`excessOfYourCustomsAllowanceText${language}`]}
            </p>
            <div className={styles.formGroup}>
              <label>{multiLang[`alternativeRecipientLabel${language}`]}</label>
              {!this.state.submit ?
                <input type='text' required placeholder={multiLang[`enterNamePlaceholder${language}`]} value={this.state.altRec} onChange={(e) => this.changeAlternativeValueHandler(e.target.value)} />
                : <p>{this.state.altRec}</p>
              }
            </div>
            <div className={styles.formGroup}>
              <label>{multiLang[`additionalInformationLabel${language}`]}</label>
              {!this.state.submit ?
                <input type='text' required placeholder={multiLang[`hotelPlaceholder${language}`]} value={this.state.adtInfo} onChange={(e) => this.changeAdditionalValueHandler(e.target.value)} />
                : <p>{this.state.adtInfo}</p>
              }
            </div>
            {this.state.submit ? <button className={styles.collectionBookingChangeBtnPrimary} onClick={() => this.changeAltranativehandle()}>{multiLang[`changeAlternativeRecipientText${language}`]}</button>
              : <button className={styles.collectionBookingChangeBtnPrimary} onClick={() => this.handleSubmit()}>{multiLang[`buttonSubmit${language}`]}</button>
            }
          </div>
          : null
        }
      </div>
      : null
  }
  public render() {
    const { language, multiLang } = this.props;
    return (
      <div className={styles.card}>

        <div className={styles.cardHeader}>
          <h3>{this.cardHeading()}</h3>
        </div>
        {this.state.location !== null ?
          this.state.data.trackingBookingDetails.journeyDirection === 2 && this.state.data.trackingBookingDetails.addOnProductType[0] === 2 ?
            this.changeDeliveryScreen() :
            <div className={styles.cardBody}>
              <div className={styles.mapHolder}
                style={{ backgroundImage: 'url(' + (this.state.location?.geoCoord?.latitude !== null ? this.getImageUrl(this.state.location?.geoCoord, 600, 200, this.gMapK) : '') + ')' }}>
              </div>
              <div className={styles.sectionAddress}>
                <p>{multiLang[`Postcode${language}`]}: {this.state.location.addressPostCode}</p>
              </div>
            </div>
          : null}
        {this.state.data.collectionSlot !== null && this.state.data.deliverySlot !== null
          ? this.deliveryTimeslot()
          : null
        }
      </div>
    );
  }

}

export default BookingItemsAddressComponent;



// WEBPACK FOOTER //
// ./src/components/booking-items-address/booking-items-address.component.tsx